import React, { createContext, useContext, useState } from "react";
import { MechanicsConfiguration } from "../models/mechanicsConfiguration.ts";

interface MechanicsConfigurationContextType {
  config: MechanicsConfiguration;
  setConfig: (config: MechanicsConfiguration) => void;
  handleChange: (section: keyof MechanicsConfiguration, value: any) => void;
}

const defaultConfig: MechanicsConfiguration = {
    mechanics: {
      dut_width: 50,
      dut_height: 100,
      housing: "m2",
      user_interface: true,
      contacting: "stack",
      switch: true,
    },
    arrangement: {
      x: { count: 1, offset: 0, distance: 10 },
      y: { count: 1, offset: 0, distance: 10 },
    },
    dut_to_zero_mechanics: {
      rotation: 0,
      offset: { x: 0, y: 0 },
    },
    testpoints:[],
};

const MechanicsConfigurationContext = createContext<MechanicsConfigurationContextType | undefined>(undefined);

export const useMechanicsConfiguration = () => {
  const context = useContext(MechanicsConfigurationContext);
  if (!context) {
    throw new Error("useMechanicsConfiguration must be used within a MechanicsConfigurationProvider");
  }
  return context;
};

export const MechanicsConfigurationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [config, setConfig] = useState<MechanicsConfiguration>(defaultConfig);

  const handleChange = (section: keyof MechanicsConfiguration, value: any) => {
    setConfig(prev => ({ ...prev, [section]: value }));
  };

  return (
    <MechanicsConfigurationContext.Provider value={{ config, setConfig, handleChange }}>
      {children}
    </MechanicsConfigurationContext.Provider>
  );
};
